import React from 'react';
import {
  Grid, Typography, TextField,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useFormikContext } from 'formik';
import _ from 'lodash';
import { NumericFormat } from 'react-number-format';
import { WIZARD_QUESTIONS, FILING_STATUS } from '../../../../constants';

const SecondStep = () => {
  const largeScreen = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const { setFieldValue, errors, values } = useFormikContext();
  const [currentAge, setCurrentAge] = React.useState(_.get(values, 'benefitEstimator.currentAge'));
  const [spouseCurrentAge, setSpouseCurrentAge] = React.useState(_.get(values, 'benefitEstimator.spouseCurrentAge'));
  const filingStatus = _.get(values, 'benefitEstimator.filingStatus');

  const handlerCurrentAge = (value) => {
    setCurrentAge(value);
    setFieldValue('benefitEstimator.currentAge', value);
  };

  const handlerSpouseCurrentAge = (value) => {
    setSpouseCurrentAge(value);
    setFieldValue('benefitEstimator.spouseCurrentAge', value);
  };

  return (
    <Grid container spacing={2} direction='column'>
      <Typography className='steps-wizard-steps question-text no-wrap-text'>{filingStatus === FILING_STATUS.SINGLE ? WIZARD_QUESTIONS.AGES.SINGLE : WIZARD_QUESTIONS.AGES.JOINT}</Typography>
      <Grid container flexDirection={largeScreen ? 'row' : 'column'} alignItems='flex-start' className={!largeScreen ? 'wizard-step-input-container' : ''}>
        {
          filingStatus === FILING_STATUS.SINGLE
            ? (
              <NumericFormat
                name='currentAge'
                className='steps-wizard-steps answer-input answer-input-mt answer-input-small'
                value={currentAge}
                customInput={TextField}
                inputProps={{
                  maxLength: 2,
                }}
                error={_.has(errors, 'benefitEstimator.currentAge')}
                helperText={_.get(errors, 'benefitEstimator.currentAge')}
                required
                onValueChange={(numberFormatValues) => {
                  const { value } = numberFormatValues;
                  handlerCurrentAge(value);
                }}
              />
            )
            : (
              <>
                <Grid item>
                  <Typography className='steps-wizard-steps answer-text'>
                    Your Age
                  </Typography>
                  <NumericFormat
                    name='currentAge'
                    className={`steps-wizard-steps answer-input ${largeScreen ? 'answer-input-mr' : undefined} answer-input-small`}
                    value={currentAge}
                    customInput={TextField}
                    inputProps={{
                      maxLength: 2,
                    }}
                    error={_.has(errors, 'benefitEstimator.currentAge')}
                    helperText={_.get(errors, 'benefitEstimator.currentAge')}
                    required
                    onValueChange={(numberFormatValues) => {
                      const { value } = numberFormatValues;
                      handlerCurrentAge(value);
                    }}
                  />
                </Grid>
                <Grid item>
                  <Typography className='steps-wizard-steps answer-text'>
                    Your Spouse&apos;s Age
                  </Typography>
                  <NumericFormat
                    name='spouseCurrentAge'
                    className={`steps-wizard-steps answer-input ${largeScreen ? 'answer-input-mr' : undefined} answer-input-small error-message-lg`}
                    value={spouseCurrentAge}
                    customInput={TextField}
                    inputProps={{
                      maxLength: 2,
                    }}
                    error={_.has(errors, 'benefitEstimator.spouseCurrentAge')}
                    helperText={_.get(errors, 'benefitEstimator.spouseCurrentAge')}
                    required
                    onValueChange={(numberFormatValues) => {
                      const { value } = numberFormatValues;
                      handlerSpouseCurrentAge(value);
                    }}
                  />
                </Grid>
              </>
            )
        }
      </Grid>
    </Grid>
  );
};

export default SecondStep;
